/*
* A function that given a set of arguments, returns corresponding SDMX Url.
* Useful to give the SDMX source of set of data. 
*
* @memberOf SDMXJS
* @api public
* @tag parsing
* @param {Object}
* @return {String}
*
* @example
* const args = {
*  ...
* }; // see getRequestArgs for args definition. 
*
* SDMXJS.getData(args)
*   .then(data => successCallback(data))
*   .catch(error => errorCallback(error));
*/
import qs from 'qs';
import { getRequestArgs } from '../getRequestArgs';
export var getSDMXUrl = function getSDMXUrl(args) {
  var _getRequestArgs = getRequestArgs(args),
    url = _getRequestArgs.url,
    params = _getRequestArgs.params;
  return '' + url + qs.stringify(params, {
    addQueryPrefix: true
  });
};